import { Question } from 'router/subrouters/DataRoom/models/QAndA';
import { DealRoom } from './DealRoom';
import { Listing } from './Listing';
import { User } from './User';
import ChatIcon from 'icons/Chat.icon';
import DocumentIcon from 'icons/Document.icon';
import { ObjectValues } from 'types';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import { DataRoomShareableLink } from './ShareableLink';
import { NdaProvider } from './Agreement';

export const LEAD_PULSE_CHECK_CODE = 63;

export const NOTIFICATION_TYPE = {
  // Buyer Notifications
  MOVED_TO_ACCEPTED_STATE_BY_SELLER: 'Moved to accepted state by seller',
  MOVED_TO_CONFIRMED_STATE_BY_SELLER: 'Moved to confirmed state by seller',
  MOVED_TO_OFFER_STATE_BY_SELLER: 'Moved to offer state by seller',
  SELLER_ACCEPT_BUYER_OFFER: 'Seller accept buyer offer',
  SELLER_REJECT_BUYER_OFFER: 'Seller reject buyer offer',
  SELLER_MARK_LISTING_AS_SOLD: 'Seller mark listing as sold',
  RECEIVED_MESSAGE_FROM_SELLER: 'Received message form seller',
  NEW_LISTING_MATCH_BUYER_PREFERENCES: 'New listing match buyer preferences',
  ANY_BUYER_TRIED_TO_WITHDRAW_INTERTEST: 'Any buyer tried to withdraw interest',
  FILE_ACCEESS_NOTIFICATION: 'File access notification',
  ACCESABLE_DOCUMENTS_AFTER_SIGN_NDA: 'Accesable documents after sign NDA',
  SENT_NDA: 'Sent NDA',
  SIGNED_NDA: 'Signed NDA',

  // Seller Notifications
  LISTING_EXPIRING_WITHIN_7_DAYS: 'Listing is expiring within 7 days',
  LISTING_EXPIRING_WITHIN_24_HOURS: 'Listing is expiring within 24 hours',
  ANY_BUYER_ENQUIRED_LISTING: 'Any buyer enquired listing',
  ANY_BUYER_CONFIRMED_INTEREST: 'Any buyer confirmed interest',
  BUYER_SUBMIT_NBIO: 'Buyer submit NBIO',
  RECEIVED_MESSAGE_FROM_BUYER: 'Received message form buyer',
  MESSAGING_ENABLED: 'Messaging enabled',

  // Q&A
  // Data room buy side members
  NEW_QUESTION_DRAFTED: 'New question drafted by buy side',
  QUESTION_REJECTED_BUY_SIDE: 'Question rejected by buy side',
  QUESTION_REJECTED_SELL_SIDE: 'Question rejected by sell side',
  QUESTION_EDITED: 'Question edited and should be checked',
  QUESTION_DELETED: 'Question deleted',
  QUESTION_REPLIED: 'Question replied by sell side',
  // Data room sell side members
  NEW_QUESTION_SUBMITTED: 'New question submitted by buy side',
  QUESTION_ASSIGNED_TO_EXPERTS: 'Question assigned to experts',
  ANSWER_REJECTED: 'Answer rejected by sell side',

  // DR FILES
  DOWNLOADED_FILE_EXPIRE_IN_TWO_DAYS: 'Downloaded file expire in two days',

  // FAQ
  NEW_FAQ_QUESTION_PUBLISHED: 'New faq question published',

  // Notes
  USER_TAGGED_IN_LEAD_NOTE: 'User tagged in lead note',

  // RFI
  DATA_ROOM_RFI_SUBMITED: 'Data room rfi submitted',

  // BOSS MODE
  NEW_MESSAGES_BOSS_MODE: 'New message boss mode',
  NEW_ENQUIRIES_BOSS_MODE: 'New enquiries boss mode',

  DATA_ROOM_GRANT_ACCESS: 'Data room grant access',

  CONFIRM_OR_WITHDRAW: 'Confirm or withdraw interest',

  NUDGE_NOTIFICATION_CONFIRMED: 'Nudge notification confirmed',

  REQUEST_DATA_ROOM_ACCESS: 'Request data room access',
  ACCEPT_DATA_ROOM_ACCESS_REQUEST: 'Accept data room access request',
  DECLINE_DATA_ROOM_ACCESS_REQUEST: 'Decline data room access request',

  DEAL_ROOM_NOTES: 'User tagged in deal note',
  SETTLEMENT_INFO_REMINDER: 'Settlement info reminder',

  INACTIVE_DEAL_ROOM_PULSE_CHECK_NOTIFICATION: 'Inactive deal room check',

  DATA_ROOM_ADDED_COLLEAGUE: 'Data room added colleague',

  DATA_ROOM_BUY_SIDE_UPLOAD_FILES: 'Data room buy side upload files',

  BOSS_MODE_NEW_DEAL_ROOM_NOTE: 'Boss mode new deal room note',
  BOSS_MODE_NEW_LEAD_NOTE: 'Boss mode new lead note',

  INOVICE_CREATED_AND_DEAL_NOT_TRANSFERRED_TO_CLIENT:
    'Invoice has been created && a deal is not transferred to the client',
  INOVICE_CREATED_AND_DEAL_TRANSFERRED_TO_CLIENT:
    'Invoice has been created && a deal is transferred to the client',

  CONFIRM_FILES_ACCESS: 'Confirm data room file access',
  CONFIRMED_FILES_ACCESS: 'Confirmed data room file access',
  REMOVED_FILES_ACCESS: 'Removed data room file access',

  REJECTED_SECURE_LINK_ACCESS: 'Rejected secure link access',
  ACCEPTED_SECURE_LINK_ACCESS: 'Accepetd secure link access',

  LEAD_PULSE_CHECK: 'Lead pulse check',
  LEAD_PULSE_CHECK_REACTION: 'Lead pulse check reaction',

  LEAD_ADDED_TO_DEAL: 'Lead added to deal',

  FILES_IN_DR_AWAITING_REVIEW: 'Files in Data Room awaiting review',

  SHAREABLE_LINK_CONSUMER_ACCESSED: 'Shareable link consumer accessed',
  SHAREABLE_LINK_WAITING_ROOM_ENTRY: 'Shareable link waiting room entry',

  CONFIRMED_INTEREST_PROGRESSING_ANSWER:
    'Confirmed interest progressing answer',
  CONFIRMED_INTEREST_NON_PROGRESSING_ANSWER:
    'Confirmed interest non-progressing answer',
  CONFIRMED_INTEREST_NO_ANSWER_KEEP: 'Confirmed interest no answer keep',
  CONFIRMED_INTEREST_AUTO_ADVANCED: 'Confirmed interest auto advanced',
  UNSURE_INTEREST_PROGRESSING_ANSWER: 'Unsure interest progressing answer',
  UNSURE_INTEREST_NON_PROGRESSING_ANSWER:
    'Unsure interest non-progressing answer',
  UNSURE_INTEREST_NO_ANSWER_KEEP: 'Unsure interest no answer keep',
  UNSURE_INTEREST_AUTO_ADVANCED: 'Unsure interest auto advanced',
  INTEREST_POPUP_NOT_INTERESTED: 'Interest popup not interested',
  PROGRESSION_QUESTION_PROGRESSING: 'Progression question progressing',
  PROGRESSION_QUESTION_NON_PROGRESSING: 'Progression question non-progressing',
  PROGRESSION_QUESTION_NO_ANSWER: 'Progression question no answer',
  AUTOMATION_NO_RESPONSE: 'Automation no response',
  RELEASE_ORDER_COMPLETED_STAYED: 'Release order completed stayed',

  PHONE_NUMBER_VERIFICATION_TRANSFERRED:
    'Phone number verification transferred',
} as const;

export const NOTIFICATION_TYPE_CODE = {
  // Buyer Notifications
  // Moved to accepted state by seller=0
  [NOTIFICATION_TYPE.MOVED_TO_ACCEPTED_STATE_BY_SELLER]: 0,
  // Moved to confirmed state by seller=1
  [NOTIFICATION_TYPE.MOVED_TO_CONFIRMED_STATE_BY_SELLER]: 1,
  // Moved to offer state by seller=2
  [NOTIFICATION_TYPE.MOVED_TO_OFFER_STATE_BY_SELLER]: 2,
  // Seller accept buyer offer=4
  [NOTIFICATION_TYPE.SELLER_ACCEPT_BUYER_OFFER]: 4,
  // Seller reject buyer offer=5
  [NOTIFICATION_TYPE.SELLER_REJECT_BUYER_OFFER]: 5,
  // Seller mark listing as sold=7
  [NOTIFICATION_TYPE.SELLER_MARK_LISTING_AS_SOLD]: 7,
  // Received message form seller=8
  [NOTIFICATION_TYPE.RECEIVED_MESSAGE_FROM_SELLER]: 8,
  // New listing match buyer preferences=9
  [NOTIFICATION_TYPE.NEW_LISTING_MATCH_BUYER_PREFERENCES]: 9,
  // Seller Notifications
  // Listing is expiring within 7 days=10
  [NOTIFICATION_TYPE.LISTING_EXPIRING_WITHIN_7_DAYS]: 10,
  // Listing is expiring within 24 hours=11
  [NOTIFICATION_TYPE.LISTING_EXPIRING_WITHIN_24_HOURS]: 11,
  // Any buyer enquired listing=12
  [NOTIFICATION_TYPE.ANY_BUYER_ENQUIRED_LISTING]: 12,
  // Any buyer confirmed interest=12
  [NOTIFICATION_TYPE.ANY_BUYER_CONFIRMED_INTEREST]: 13,
  // Buyer submit NBIO=16
  [NOTIFICATION_TYPE.BUYER_SUBMIT_NBIO]: 16,
  // Received message form buyer=17
  [NOTIFICATION_TYPE.RECEIVED_MESSAGE_FROM_BUYER]: 17,
  [NOTIFICATION_TYPE.MESSAGING_ENABLED]: 19,
  // Any buyer tried to withdraw interest
  [NOTIFICATION_TYPE.ANY_BUYER_TRIED_TO_WITHDRAW_INTERTEST]: 22,
  [NOTIFICATION_TYPE.FILE_ACCEESS_NOTIFICATION]: 23,
  [NOTIFICATION_TYPE.ACCESABLE_DOCUMENTS_AFTER_SIGN_NDA]: 24,
  [NOTIFICATION_TYPE.SENT_NDA]: 25,
  [NOTIFICATION_TYPE.SIGNED_NDA]: 26,
  // Q&A
  // Data room buy side members
  [NOTIFICATION_TYPE.NEW_QUESTION_DRAFTED]: 27,
  [NOTIFICATION_TYPE.QUESTION_REJECTED_BUY_SIDE]: 28,
  [NOTIFICATION_TYPE.QUESTION_REJECTED_SELL_SIDE]: 29,
  [NOTIFICATION_TYPE.QUESTION_EDITED]: 30,
  [NOTIFICATION_TYPE.QUESTION_DELETED]: 31,
  [NOTIFICATION_TYPE.QUESTION_REPLIED]: 32,
  // Data room sell side members
  [NOTIFICATION_TYPE.NEW_QUESTION_SUBMITTED]: 33,
  [NOTIFICATION_TYPE.QUESTION_ASSIGNED_TO_EXPERTS]: 34,
  [NOTIFICATION_TYPE.ANSWER_REJECTED]: 35,
  // FAQ
  [NOTIFICATION_TYPE.NEW_FAQ_QUESTION_PUBLISHED]: 36,
  // Notes
  [NOTIFICATION_TYPE.USER_TAGGED_IN_LEAD_NOTE]: 37,
  // RFI
  [NOTIFICATION_TYPE.DATA_ROOM_RFI_SUBMITED]: 38,
  // BOSS MODE
  [NOTIFICATION_TYPE.NEW_MESSAGES_BOSS_MODE]: 39,
  [NOTIFICATION_TYPE.NEW_ENQUIRIES_BOSS_MODE]: 40,

  [NOTIFICATION_TYPE.DATA_ROOM_GRANT_ACCESS]: 41,

  [NOTIFICATION_TYPE.CONFIRM_OR_WITHDRAW]: 42,
  [NOTIFICATION_TYPE.NUDGE_NOTIFICATION_CONFIRMED]: 43,

  [NOTIFICATION_TYPE.REQUEST_DATA_ROOM_ACCESS]: 45,
  [NOTIFICATION_TYPE.ACCEPT_DATA_ROOM_ACCESS_REQUEST]: 46,
  [NOTIFICATION_TYPE.DECLINE_DATA_ROOM_ACCESS_REQUEST]: 47,

  [NOTIFICATION_TYPE.DEAL_ROOM_NOTES]: 48,
  [NOTIFICATION_TYPE.SETTLEMENT_INFO_REMINDER]: 49,

  // DR FILES
  [NOTIFICATION_TYPE.DOWNLOADED_FILE_EXPIRE_IN_TWO_DAYS]: 50,

  [NOTIFICATION_TYPE.INACTIVE_DEAL_ROOM_PULSE_CHECK_NOTIFICATION]: 51,
  [NOTIFICATION_TYPE.DATA_ROOM_ADDED_COLLEAGUE]: 52,

  [NOTIFICATION_TYPE.DATA_ROOM_BUY_SIDE_UPLOAD_FILES]: 53,

  [NOTIFICATION_TYPE.BOSS_MODE_NEW_DEAL_ROOM_NOTE]: 54,
  [NOTIFICATION_TYPE.BOSS_MODE_NEW_LEAD_NOTE]: 55,

  [NOTIFICATION_TYPE.INOVICE_CREATED_AND_DEAL_NOT_TRANSFERRED_TO_CLIENT]: 56,
  [NOTIFICATION_TYPE.INOVICE_CREATED_AND_DEAL_TRANSFERRED_TO_CLIENT]: 57,

  [NOTIFICATION_TYPE.CONFIRM_FILES_ACCESS]: 58,
  [NOTIFICATION_TYPE.CONFIRMED_FILES_ACCESS]: 59,
  [NOTIFICATION_TYPE.REMOVED_FILES_ACCESS]: 60,

  [NOTIFICATION_TYPE.ACCEPTED_SECURE_LINK_ACCESS]: 61,
  [NOTIFICATION_TYPE.REJECTED_SECURE_LINK_ACCESS]: 62,

  [NOTIFICATION_TYPE.LEAD_PULSE_CHECK]: LEAD_PULSE_CHECK_CODE,
  [NOTIFICATION_TYPE.LEAD_PULSE_CHECK_REACTION]: 64,

  [NOTIFICATION_TYPE.LEAD_ADDED_TO_DEAL]: 65,

  [NOTIFICATION_TYPE.FILES_IN_DR_AWAITING_REVIEW]: 66,

  [NOTIFICATION_TYPE.SHAREABLE_LINK_CONSUMER_ACCESSED]: 67,
  [NOTIFICATION_TYPE.SHAREABLE_LINK_WAITING_ROOM_ENTRY]: 68,

  [NOTIFICATION_TYPE.CONFIRMED_INTEREST_PROGRESSING_ANSWER]: 69,
  [NOTIFICATION_TYPE.CONFIRMED_INTEREST_NON_PROGRESSING_ANSWER]: 70,
  [NOTIFICATION_TYPE.CONFIRMED_INTEREST_NO_ANSWER_KEEP]: 71,
  [NOTIFICATION_TYPE.CONFIRMED_INTEREST_AUTO_ADVANCED]: 72,
  [NOTIFICATION_TYPE.UNSURE_INTEREST_PROGRESSING_ANSWER]: 73,
  [NOTIFICATION_TYPE.UNSURE_INTEREST_NON_PROGRESSING_ANSWER]: 74,
  [NOTIFICATION_TYPE.UNSURE_INTEREST_NO_ANSWER_KEEP]: 75,
  [NOTIFICATION_TYPE.UNSURE_INTEREST_AUTO_ADVANCED]: 76,
  [NOTIFICATION_TYPE.PROGRESSION_QUESTION_PROGRESSING]: 77,
  [NOTIFICATION_TYPE.PROGRESSION_QUESTION_NON_PROGRESSING]: 78,
  [NOTIFICATION_TYPE.PROGRESSION_QUESTION_NO_ANSWER]: 79,
  [NOTIFICATION_TYPE.INTEREST_POPUP_NOT_INTERESTED]: 80,
  [NOTIFICATION_TYPE.AUTOMATION_NO_RESPONSE]: 81,
  [NOTIFICATION_TYPE.PHONE_NUMBER_VERIFICATION_TRANSFERRED]: 82,
  [NOTIFICATION_TYPE.RELEASE_ORDER_COMPLETED_STAYED]: 83,
};

export const NOTIFICATIONS_TRANSLATIONS = {
  // Buyer Notifications
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.MOVED_TO_ACCEPTED_STATE_BY_SELLER]]:
    'movedToAcceptedStateBySeller',
  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.MOVED_TO_CONFIRMED_STATE_BY_SELLER
  ]]: 'movedToConfirmedStateBySeller',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.MOVED_TO_OFFER_STATE_BY_SELLER]]:
    'movedToOfferStateBySeller',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.SELLER_ACCEPT_BUYER_OFFER]]:
    'sellerAcceptBuyerOffer',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.SELLER_REJECT_BUYER_OFFER]]:
    'sellerRejectBuyerOffer',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.SELLER_MARK_LISTING_AS_SOLD]]:
    'sellerMarkListingAsSold',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.RECEIVED_MESSAGE_FROM_SELLER]]:
    'receivedMessageFromSeller',
  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.NEW_LISTING_MATCH_BUYER_PREFERENCES
  ]]: 'newListingMatchBuyerPreferences',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.SENT_NDA]]:
    'viewAndSignNDANotification',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.SIGNED_NDA]]: 'viewNDANotification',

  // Seller Notifications
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.LISTING_EXPIRING_WITHIN_7_DAYS]]:
    'listingExpiringWithin7Days',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.LISTING_EXPIRING_WITHIN_24_HOURS]]:
    'litingExpiringWithin24Hours',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.ANY_BUYER_ENQUIRED_LISTING]]:
    'anyBuyerEnequiredListing',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.ANY_BUYER_CONFIRMED_INTEREST]]:
    'anyBuyerConfirmedInterest',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.BUYER_SUBMIT_NBIO]]:
    'buyerSubmitNbio',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.RECEIVED_MESSAGE_FROM_BUYER]]:
    'receivedMessageFromBuyer',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.MESSAGING_ENABLED]]:
    'youCanStartTalkgingWithSeller',
  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.ANY_BUYER_TRIED_TO_WITHDRAW_INTERTEST
  ]]: 'anyBuyerTriedWithdrawal',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.FILE_ACCEESS_NOTIFICATION]]:
    'fileAccessNotification',
  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.ACCESABLE_DOCUMENTS_AFTER_SIGN_NDA
  ]]: 'accesableDocumentsAfterSignNDA',

  // QA
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.NEW_QUESTION_DRAFTED]]:
    'newQuestionDraftedNotification',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.QUESTION_REJECTED_BUY_SIDE]]:
    'questionRejectedBuySideNotification',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.QUESTION_REJECTED_SELL_SIDE]]:
    'questionRejectedSellSideNotification',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.QUESTION_EDITED]]:
    'questionEditedNotification',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.QUESTION_DELETED]]:
    'questionDeletedNotification',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.QUESTION_REPLIED]]:
    'questionRepliedNotification',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.NEW_QUESTION_SUBMITTED]]:
    'newQuestionSubmittedNotification',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.QUESTION_ASSIGNED_TO_EXPERTS]]:
    'questionAssignedToExpertNotification',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.ANSWER_REJECTED]]:
    'answerRejectedNotification',

  // FAQ
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.NEW_FAQ_QUESTION_PUBLISHED]]:
    'newFaqQuestionPublished',

  // Notes
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.USER_TAGGED_IN_LEAD_NOTE]]:
    'newLeadNoteTag',

  // RFI
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.DATA_ROOM_RFI_SUBMITED]]:
    'dataRoomRfiSubmited',

  // BOSS MODE
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.NEW_MESSAGES_BOSS_MODE]]:
    'newMessageBossMode',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.NEW_ENQUIRIES_BOSS_MODE]]:
    'newEnquiriesBossMode',

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.DATA_ROOM_GRANT_ACCESS]]:
    'dataRoomGrantAccessNotification',

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.CONFIRM_OR_WITHDRAW]]:
    'confirmOrWithdrawInterestNotification',

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.NUDGE_NOTIFICATION_CONFIRMED]]:
    'nudgeNotificationConfirmed',

  // ENTERPRISE
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.REQUEST_DATA_ROOM_ACCESS]]:
    'requestDataRoomAccess',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.ACCEPT_DATA_ROOM_ACCESS_REQUEST]]:
    'acceptedDataRoomAccess',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.DECLINE_DATA_ROOM_ACCESS_REQUEST]]:
    'declinedDataRoomAccess',

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.DEAL_ROOM_NOTES]]:
    'taggedInNoteRegardingDeal',

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.SETTLEMENT_INFO_REMINDER]]:
    'fillInSettlementInfo',

  // DR FILES
  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.DOWNLOADED_FILE_EXPIRE_IN_TWO_DAYS
  ]]: 'downloadedFileExpireInTwoDays',

  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.INACTIVE_DEAL_ROOM_PULSE_CHECK_NOTIFICATION
  ]]: 'quickCheckPulse',

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.DATA_ROOM_ADDED_COLLEAGUE]]:
    'addedToDRAsColleague',

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.DATA_ROOM_BUY_SIDE_UPLOAD_FILES]]:
    'dataRoomBuySideUploadFiles',

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.BOSS_MODE_NEW_DEAL_ROOM_NOTE]]:
    'newDealNoteBossMode',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.BOSS_MODE_NEW_LEAD_NOTE]]:
    'newLeadNoteBossMode',

  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.INOVICE_CREATED_AND_DEAL_NOT_TRANSFERRED_TO_CLIENT
  ]]: 'invoiceCreatedAndDealNotTransferred',

  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.INOVICE_CREATED_AND_DEAL_TRANSFERRED_TO_CLIENT
  ]]: 'invoiceCreatedAndDealTransferred',

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.CONFIRM_FILES_ACCESS]]:
    'confirmFilesAccess',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.CONFIRMED_FILES_ACCESS]]:
    'confirmedRetainAccess',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.REMOVED_FILES_ACCESS]]:
    'rejectedRetainAccess',

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.REJECTED_SECURE_LINK_ACCESS]]:
    'rejectedSecureLinkAccess',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.ACCEPTED_SECURE_LINK_ACCESS]]:
    'acceptedSecureLinkAccess',

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.LEAD_PULSE_CHECK]]:
    'leadPulseCheckSent',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.LEAD_PULSE_CHECK_REACTION]]:
    'leadPulseCheckReaction',

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.LEAD_ADDED_TO_DEAL]]:
    'youHaveBeenAddedToDeal',

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.FILES_IN_DR_AWAITING_REVIEW]]:
    'filesInDataRoom',

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.SHAREABLE_LINK_CONSUMER_ACCESSED]]:
    'userSubmittedSLForm',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.SHAREABLE_LINK_WAITING_ROOM_ENTRY]]:
    'userWaitingForSLAccess',
  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.CONFIRMED_INTEREST_PROGRESSING_ANSWER
  ]]: 'confirmedInterestProgressingAnswer',
  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.CONFIRMED_INTEREST_NON_PROGRESSING_ANSWER
  ]]: 'confirmedInterestNonProgressingAnswer',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.CONFIRMED_INTEREST_NO_ANSWER_KEEP]]:
    'confirmedInterestNoAnswer',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.CONFIRMED_INTEREST_AUTO_ADVANCED]]:
    'confirmedInterestAutoAdvanced',
  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.UNSURE_INTEREST_PROGRESSING_ANSWER
  ]]: 'unsureProgressingAnswer',
  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.UNSURE_INTEREST_NON_PROGRESSING_ANSWER
  ]]: 'unsureNonProgressingAnswer',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.UNSURE_INTEREST_NO_ANSWER_KEEP]]:
    'unsureNoProgression',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.UNSURE_INTEREST_AUTO_ADVANCED]]:
    'unsureInterestAutoAdvanced',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.PROGRESSION_QUESTION_PROGRESSING]]:
    'progressionQuestionOnlyProgressingAnswer',
  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.PROGRESSION_QUESTION_NON_PROGRESSING
  ]]: 'progressionQuestionOnlyNonProgressingAnswer',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.PROGRESSION_QUESTION_NO_ANSWER]]:
    'progressionQuestionOnlyNoAnswer',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.INTEREST_POPUP_NOT_INTERESTED]]:
    'notInterestedWithdrew',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.AUTOMATION_NO_RESPONSE]]:
    'automationNoResponse',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.RELEASE_ORDER_COMPLETED_STAYED]]:
    'releaseOrderCompletedStayed',

  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.PHONE_NUMBER_VERIFICATION_TRANSFERRED
  ]]: 'phoneVerificationTransferred',
} as Record<number, string>;

export const NOTIFICATIONS_CTA_TRANSLATIONS = {
  // Buyer Notifications
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.MOVED_TO_ACCEPTED_STATE_BY_SELLER]]:
    'viewDeal',
  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.MOVED_TO_CONFIRMED_STATE_BY_SELLER
  ]]: 'viewListing',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.MOVED_TO_OFFER_STATE_BY_SELLER]]:
    'viewListing',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.SELLER_ACCEPT_BUYER_OFFER]]:
    'viewListing',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.SELLER_REJECT_BUYER_OFFER]]:
    'viewListing',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.SELLER_MARK_LISTING_AS_SOLD]]:
    'viewListing',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.RECEIVED_MESSAGE_FROM_SELLER]]:
    'viewMessage',
  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.NEW_LISTING_MATCH_BUYER_PREFERENCES
  ]]: 'viewListing',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.SENT_NDA]]: 'viewAndSignNDA',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.SIGNED_NDA]]: 'viewNDA',

  // Seller Notifications
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.LISTING_EXPIRING_WITHIN_7_DAYS]]:
    'viewListing',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.LISTING_EXPIRING_WITHIN_24_HOURS]]:
    'viewListing',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.ANY_BUYER_ENQUIRED_LISTING]]:
    'viewLeads',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.ANY_BUYER_CONFIRMED_INTEREST]]:
    'viewListing',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.BUYER_SUBMIT_NBIO]]: 'viewLeads',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.RECEIVED_MESSAGE_FROM_BUYER]]:
    'viewMessage',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.MESSAGING_ENABLED]]:
    'messageBroker',
  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.ANY_BUYER_TRIED_TO_WITHDRAW_INTERTEST
  ]]: 'viewLeads',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.FILE_ACCEESS_NOTIFICATION]]:
    'reviewDocuments',
  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.ACCESABLE_DOCUMENTS_AFTER_SIGN_NDA
  ]]: 'reviewDocuments',

  // QA
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.NEW_QUESTION_DRAFTED]]:
    'reviewQuestion',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.QUESTION_REJECTED_BUY_SIDE]]:
    'reviewQuestion',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.QUESTION_REJECTED_SELL_SIDE]]:
    'reviewQuestion',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.QUESTION_EDITED]]: 'reviewQuestion',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.QUESTION_DELETED]]:
    'reviewQuestions',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.QUESTION_REPLIED]]: 'viewAnswer',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.NEW_QUESTION_SUBMITTED]]:
    'reviewQuestion',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.QUESTION_ASSIGNED_TO_EXPERTS]]:
    'reviewQuestion',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.ANSWER_REJECTED]]: 'reviewQuestion',

  // FAQ
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.NEW_FAQ_QUESTION_PUBLISHED]]:
    'viewFAQs',

  // Notes
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.USER_TAGGED_IN_LEAD_NOTE]]:
    'viewNotes',

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.DATA_ROOM_GRANT_ACCESS]]:
    'visitDataRoom',

  // ENTERPRISE
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.REQUEST_DATA_ROOM_ACCESS]]:
    'reviewRequest',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.ACCEPT_DATA_ROOM_ACCESS_REQUEST]]:
    'goToDataRoom',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.DECLINE_DATA_ROOM_ACCESS_REQUEST]]:
    'goToDeal',

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.DEAL_ROOM_NOTES]]: 'viewNotes',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.SETTLEMENT_INFO_REMINDER]]:
    'fillIn',

  // DR FILES
  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.DOWNLOADED_FILE_EXPIRE_IN_TWO_DAYS
  ]]: 'goToDataRoom',

  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.INACTIVE_DEAL_ROOM_PULSE_CHECK_NOTIFICATION
  ]]: 'reviewDeal',

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.DATA_ROOM_ADDED_COLLEAGUE]]:
    'accessNow',

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.DATA_ROOM_BUY_SIDE_UPLOAD_FILES]]:
    'reviewDocuments',

  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.INOVICE_CREATED_AND_DEAL_NOT_TRANSFERRED_TO_CLIENT
  ]]: 'goToContactForm',

  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.INOVICE_CREATED_AND_DEAL_TRANSFERRED_TO_CLIENT
  ]]: 'goToPortfolio',

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.CONFIRM_FILES_ACCESS]]:
    'goToDataRoom',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.CONFIRMED_FILES_ACCESS]]:
    'goToLeadsBoard',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.REMOVED_FILES_ACCESS]]:
    'goToLeadsBoard',

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.REJECTED_SECURE_LINK_ACCESS]]:
    'contactResolve',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.ACCEPTED_SECURE_LINK_ACCESS]]:
    'visitSecureLink',

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.LEAD_PULSE_CHECK]]:
    'provideFeedback',

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.LEAD_ADDED_TO_DEAL]]: 'seeDeal',

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.FILES_IN_DR_AWAITING_REVIEW]]:
    'goToDataRoom',

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.SHAREABLE_LINK_CONSUMER_ACCESSED]]:
    'goToSecureLink',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.SHAREABLE_LINK_WAITING_ROOM_ENTRY]]:
    'goToWaitingRoom',
  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.CONFIRMED_INTEREST_PROGRESSING_ANSWER
  ]]: 'viewLead',
  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.CONFIRMED_INTEREST_NON_PROGRESSING_ANSWER
  ]]: 'viewLead',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.CONFIRMED_INTEREST_NO_ANSWER_KEEP]]:
    'viewLead',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.CONFIRMED_INTEREST_AUTO_ADVANCED]]:
    'viewLead',
  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.UNSURE_INTEREST_PROGRESSING_ANSWER
  ]]: 'viewLead',
  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.UNSURE_INTEREST_NON_PROGRESSING_ANSWER
  ]]: 'viewLead',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.UNSURE_INTEREST_NO_ANSWER_KEEP]]:
    'viewLead',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.UNSURE_INTEREST_AUTO_ADVANCED]]:
    'viewLead',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.PROGRESSION_QUESTION_PROGRESSING]]:
    'viewLead',
  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.PROGRESSION_QUESTION_NON_PROGRESSING
  ]]: 'viewLead',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.PROGRESSION_QUESTION_NO_ANSWER]]:
    'viewLead',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.INTEREST_POPUP_NOT_INTERESTED]]:
    'viewLead',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.AUTOMATION_NO_RESPONSE]]:
    'viewLead',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.RELEASE_ORDER_COMPLETED_STAYED]]:
    'viewLead',
} as Record<number, string>;

export const NOTIFICATIONS_CTA_ICON = {
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.MESSAGING_ENABLED]]: ChatIcon,
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.RECEIVED_MESSAGE_FROM_BUYER]]:
    ChatIcon,
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.RECEIVED_MESSAGE_FROM_SELLER]]:
    ChatIcon,

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.SENT_NDA]]: DocumentIcon,
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.SIGNED_NDA]]: DocumentIcon,
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.FILE_ACCEESS_NOTIFICATION]]:
    DocumentIcon,
  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.ACCESABLE_DOCUMENTS_AFTER_SIGN_NDA
  ]]: DocumentIcon,
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.DATA_ROOM_BUY_SIDE_UPLOAD_FILES]]:
    DocumentIcon,
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.CONFIRM_FILES_ACCESS]]:
    DocumentIcon,
} as Record<number, React.FC>;

export const NOTIFICATIONS_CTA_PRIMARY_TRANSLATIONS = {
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.CONFIRM_OR_WITHDRAW]]:
    'stillInterested',
} as Record<number, string>;

export const NOTIFICATIONS_CTA_SECONDARY_TRANSLATIONS = {
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.CONFIRM_OR_WITHDRAW]]: 'notForMe',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.FILE_ACCEESS_NOTIFICATION]]:
    'reviewDocuments',
  [NOTIFICATION_TYPE_CODE[
    NOTIFICATION_TYPE.ACCESABLE_DOCUMENTS_AFTER_SIGN_NDA
  ]]: 'reviewDocuments',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.DATA_ROOM_BUY_SIDE_UPLOAD_FILES]]:
    'reviewDocuments',

  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.BOSS_MODE_NEW_DEAL_ROOM_NOTE]]:
    'viewNotes',
  [NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.BOSS_MODE_NEW_LEAD_NOTE]]:
    'viewNotes',
} as Record<number, string>;

export type NotificationTypes =
  typeof NOTIFICATION_TYPE[keyof typeof NOTIFICATION_TYPE];

export type NotificationContent = {
  listing: Listing;
  dealRoom: DealRoom;
  listingId: string;
  senderId: string;
  sender: User;
  numberOfEnabledDocuments?: number;
  sessionId?: string;
  envelopeId?: string;
  ndaProvider?: NdaProvider;
  // Deprecated: Used for old notifications only
  envelopeTemplateUrl?: string;
  dataRoomQuestionId?: string;
  dataRoomQuestion?: Question;
  // only for delete notification
  dataRoomQuestionSubject?: string;
  fileNames?: string[];
  firstParticipant?: User;
  secondParticipant?: User;
  //lead
  lead?: User;
  leadId?: string;
  nudgeNotificationId?: string;
  // open node via notification
  dataRoomNode?: DataRoomNode;

  group: NotificationGroup;

  shareableLinkId?: string;
  shareableLink?: DataRoomShareableLink;

  // Workflow automation events
  withdrawnInterest?: boolean;
};

export const USER_TYPE_NOTIFICATION = {
  SELLER: 'seller',
  BUYER: 'buyer',
} as const;

export type UserTypeNotification = ObjectValues<typeof USER_TYPE_NOTIFICATION>;

export type NotificationType = {
  _id: string;
  id: string;
  user: User;
  createdAt: string;
  updatedAt: string;
  isRead: boolean;
  dataRoomId: string;
  typeCode: number;
  content: NotificationContent;
  userType: UserTypeNotification;
  justNotify: boolean;
};

const NUDGE_NOTIFICATION_STATUS = {
  ACTIVE: 'active',
  CONFIRMED: 'confirmed',
  WITHDRAWN: 'withdrawn',
} as const;

type NudgeNotificationStatus = ObjectValues<typeof NUDGE_NOTIFICATION_STATUS>;

export type NudgeNotification = {
  _id: string;

  dataRoomNodeIds: string[];
  dataRoomNodes: DataRoomNode[];

  sentPlatformNotification: boolean;

  //when someone confirm interest or withdraw set archived on true
  archived: boolean;
  status: NudgeNotificationStatus;
  snoozedDate: Date;
  archivedDate: Date;

  leadId: string;

  listingId: string;
  listing: Partial<Listing> | null;

  createdAt: Date;
  updatedAt: Date;
};

export const NOTIFICATION_STATUS = {
  ALL: 'ALL',
  UNREAD: 'UNREAD',
} as const;

export type NotificationsStatus = ObjectValues<typeof NOTIFICATION_STATUS>;

export const NOTIFICATION_GROUP = {
  FYA: 'fya',
  FYI: 'fyi',
} as const;

export type NotificationGroup = ObjectValues<typeof NOTIFICATION_GROUP>;

export const NOTIFICATION_BY = {
  FOR_YOU: 'forYou',
  FOR_YOUR_LEADS: 'forYourLeads',
} as const;

export type NotificationBy = ObjectValues<typeof NOTIFICATION_BY>;

export const DONT_NOTIFY = [42];

export const NOTIFICATIONS_LIMIT = 10;

export const NOTIFICATIONS_NUMBER_OF_PLACEHOLDERS = {
  INITIAL_LOADING_COUNT: NOTIFICATIONS_LIMIT,
  PAGINATED_LOADING_COUNT: 1,
} as const;

export const NOTIFICATION_MEDIUM = {
  EMAIL: 'email',
  SMS: 'sms',
  PLATFORM: 'platform',
} as const;

export type NotificationMedium = ObjectValues<typeof NOTIFICATION_MEDIUM>;
